type Row = {
  key: string;
  cells: Array<{ key: string; content: JSX.Element | string }>;
};

export const getPaginatedRows: (
  size: number,
  pagelen: number,
  page: number,
  visibleRows: Array<Row>,
  sortOrder?: 'asc' | 'desc'
) => Array<Row | { cells: [] }> = (
  size,
  pagelen,
  page,
  visibleRows,
  sortOrder = 'asc'
) => {
  if (!size) {
    return [];
  }

  // @atlaskit/dynamic-table does not take a `totalItems` prop and instead counts `rows` to calculate the total number of pages in the table.
  // Padding the `page` with dummy rows causes DynamicTable to render pagination controls that correspond to the full `size` of the response.
  const totalNumPages = Math.ceil(size / pagelen) || 1;
  const itemsBefore =
    (page - 1 > totalNumPages ? totalNumPages : page - 1) * pagelen;
  const itemsAfter =
    (page > totalNumPages ? 0 : totalNumPages - page) * pagelen;

  const getEmptyItems: (numItems: number) => Array<{ cells: [] }> = numItems =>
    Array.from(Array(numItems)).map(() => ({
      cells: [],
    }));

  return [
    ...getEmptyItems(sortOrder === 'asc' ? itemsBefore : itemsAfter),
    ...visibleRows,
    ...getEmptyItems(sortOrder === 'asc' ? itemsAfter : itemsBefore),
  ];
};
